import { render, staticRenderFns } from "./TaxReturnEffectsSection.vue?vue&type=template&id=2bcd44a6&scoped=true&"
import script from "./TaxReturnEffectsSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnEffectsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd44a6",
  null
  
)

export default component.exports